const apiVersion = 'v1';

import { StrategySite } from '@/Core.Service.Domain/Strategies/Strategies/types/strategies.ts';

const getSitesWithStrategies = async () => {
  try {
    const result = await window.axios.get(`/${apiVersion}/strategy/site/sites`);

    const { data } = result.data;
    return data;
  } catch (err) {
    return Promise.reject(err);
  }
};

const getStrategiesBySiteId = async (site: StrategySite) => {
  const { siteId } = site;
  const { id } = site;

  try {
    const strategy = await window.axios.get(
      `/${apiVersion}/strategy/site/${siteId || id}`
    );
    if (strategy && strategy.data) {
      const { data } = strategy.data;
      return data;
    } else {
      return [];
    }
  } catch (err) {
    return Promise.reject(err);
  }
};

const getStrategyTodaysHistoryByStrategyId = async (
  strategyId: number | string
) => {
  try {
    const result = await window.axios.get(
      `/${apiVersion}/strategy/${strategyId}/history`
    );
    const { data } = result.data;
    return [data];
  } catch (err) {
    return Promise.reject(err);
  }
};

const getStrategyHistoryByDate = async (
  strategyId: number | string,
  date: string
) => {
  try {
    const result = await window.axios.get(
      `/${apiVersion}/strategy/${strategyId}/history?date=${date}`
    );
    const { data } = result.data;
    return [data];
  } catch (err) {
    return Promise.reject(err);
  }
};

export default {
  getSitesWithStrategies,
  getStrategiesBySiteId,
  getStrategyTodaysHistoryByStrategyId,
  getStrategyHistoryByDate,
};
